import styled from "styled-components";

export const MetricsDashboardPageContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
`;

export const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 90vh;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
`;